import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { get } from 'lodash';
import MobileStepper from '@material-ui/core/MobileStepper';
import SwipeableViews from 'react-swipeable-views';
import { doesRequireSetup } from '../security/util';
import SetupDvrToolkitPasswordStep from './steps/SetupDvrToolkitPasswordStep';
import SetupServiceAccountStep from './steps/SetupServiceAccountStep';
import { getInfo } from '../security/SecurityActions';
import {
  loadDvrToolkitData,
  defineDvrToolkitPassword,
  createServiceAccount,
  skipServiceAccount,
} from './FirstTimeSetupActions';
import { notifySuccess } from '../globalNotification/GlobalNotificationActions';

class FirstTimeSetup extends React.Component {
  // eslint-disable-next-line react/state-in-constructor
  state = {
    currentStep: 0,
  };

  constructor(props) {
    super(props);
    this.state.currentStep = this.findCurrentStep();
  }

  componentDidMount() {
    this.props.loadDvrToolkitData();
  }

  getCurrentSetup(props = this.props) {
    return get(props, 'security.userInfo.setup', {});
  }

  handleNextStep = (_nextStep) => {
    this.setState((prevState) => ({
      currentStep: _nextStep || prevState.currentStep + 1,
    }));
  };

  handleFinalStep = () => {
    this.props.getInfo();
  };

  isSetupRequired() {
    return doesRequireSetup();
  }

  findCurrentStep() {
    const setup = this.getCurrentSetup();

    if (!setup.hasDvrToolkitPassword) {
      return 0;
    }

    return 1;
  }

  render() {
    if (!this.isSetupRequired()) {
      return <Redirect to="/" />;
    }

    const { currentStep } = this.state;

    return (
      <div>
        <div className="bodycontent__firsttimesetup">
          <MobileStepper
            className="firsttimesetup__stepper"
            variant="dots"
            steps={2}
            position="static"
            activeStep={currentStep}
          />
          <SwipeableViews
            index={currentStep}
            slideStyle={{ overflow: 'hidden' }}
          >
            <SetupDvrToolkitPasswordStep
              {...this.props.dvrToolkitPasswordStep}
              onNextStep={this.handleNextStep}
              actions={{
                defineDvrToolkitPassword: this.props.defineDvrToolkitPassword,
              }}
            />
            <SetupServiceAccountStep
              {...this.props.serviceAccountStep}
              onNextStep={this.handleFinalStep}
              actions={{
                createServiceAccount: this.props.createServiceAccount,
                skipServiceAccount: this.props.skipServiceAccount,
                notifySuccess: this.props.notifySuccess,
              }}
            />
          </SwipeableViews>
        </div>
      </div>
    );
  }
}

FirstTimeSetup.propTypes = {
  security: PropTypes.shape({
    userInfo: PropTypes.shape({
      setup: PropTypes.shape({
        hasDvrToolkitPassword: PropTypes.bool,
      }),
    }),
  }),

  loadDvrToolkitData: PropTypes.func.isRequired,
  getInfo: PropTypes.func.isRequired,

  dvrToolkitPasswordStep: PropTypes.shape({
    loading: PropTypes.bool,
    userName: PropTypes.string,
    currentPassword: PropTypes.string,
    definePassword: PropTypes.shape({
      loading: PropTypes.bool,
      success: PropTypes.bool,
      error: PropTypes.bool,
    }),
  }),

  serviceAccountStep: PropTypes.shape({
    serviceAccountCreated: PropTypes.bool,
    creating: PropTypes.bool,
    success: PropTypes.bool,
    error: PropTypes.bool,
    skipping: PropTypes.bool,
    skitError: PropTypes.bool,
  }),

  defineDvrToolkitPassword: PropTypes.func,
  createServiceAccount: PropTypes.func,
  skipServiceAccount: PropTypes.func,
  notifySuccess: PropTypes.func,
};

FirstTimeSetup.defaultProps = {
  security: {
    userInfo: {
      setup: {
        hasDvrToolkitPassword: false,
      },
    },
  },
};

const mapStateToProps = (state) => ({
  ...state.firstTimeSetup,
  security: state.security,
});

const mapDispatchToProps = {
  getInfo,
  loadDvrToolkitData,
  defineDvrToolkitPassword,
  createServiceAccount,
  skipServiceAccount,
  notifySuccess,
};

export default connect(mapStateToProps, mapDispatchToProps)(FirstTimeSetup);
